export default () => {
  const data = {
    event_name: 'tapped_text_field',
    button_name: 'message',
    page_section: 'doubt_section',
    name_of_the_page_viewed: 'home_personal',
  };
  return data;
};
